import AProgressStep from './index.vue';

AProgressStep.install = app => {
  app.component(AProgressStep.name, AProgressStep);
};

export default AProgressStep;
